"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("styled-components"),t=require("react");function o(e){return e&&e.__esModule?e:{default:e}}var i=o(e),n=o(t);const s=i.default.div.withConfig({displayName:"PhantomLinkWrapper",componentId:"VDS__sc-1jkunwc-0"})`
  display: ${({isSelected:e,isDesktop:t})=>e&&t?"inherit":"none"};
  opacity: 1;
  position: absolute;
  top: ${({position:e})=>e&&`${e.top+17}px`};
  left: ${({position:e})=>e&&`${e.left}px`};
`;exports.default=({ctaLink:e,isDesktop:t,isSelected:o,getPosition:i,onMouseEnter:a,onMouseLeave:r,TextLinkCaret:p})=>{const d=o&&i();return t&&n.default.createElement(s,{position:d,onMouseEnter:a,onMouseLeave:r,isSelected:o,isDesktop:t},n.default.createElement(p,Object.assign({ariaHidden:o,disabled:!o},e)))};



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/tabs/cjs/util/PhantomLink.js
// module id = 1263
// module chunks = 0